"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateAbExposureStreamingResponse = exports.UpdateAbExposureStreamingRequest = exports.GetAbExposureResponse = exports.AbExposureReadResponseData = exports.PerIdExposureData = exports.GetAbExposureRequest = exports.AbExposureReadRequestData = exports.GetAbExposureStreamingResponse = exports.GetAbExposureStreamingRequest = exports.GetAbExposureSizeResponse = exports.AbExposureSizeResponseData = exports.StudyTreatmentInfoWithExposureSizeData = exports.GetAbExposureSizeRequest = exports.AbExposureSizeRequestData = exports.BatchUpdateAbExposureResponse = exports.BatchUpdateAbExposureRequest = exports.AbExposureData = exports.UpdateAbExposureResponse = exports.Properties = exports.UpdateAbExposureRequest = exports.GeoData = exports.Id = exports.StudyTreatmentInfo = exports.LoggingType = exports.IdType = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(require("long"));
const minimal_1 = __importDefault(require("protobufjs/minimal"));
const guid_1 = require("./common/guid");
const ab_config_service_1 = require("./ab_config_service");
exports.protobufPackage = "snapchat.ab.exposure_service";
/** ProtoBuf API definition for AB config service. */
/** Type of id */
var IdType;
(function (IdType) {
    /** UNKNOWN_UNSET - Default, please don't use. */
    IdType[IdType["UNKNOWN_UNSET"] = 0] = "UNKNOWN_UNSET";
    /** USER - User Id. */
    IdType[IdType["USER"] = 1] = "USER";
    /** SNAPCHAT_CLIENT - Snapchat Client Id. */
    IdType[IdType["SNAPCHAT_CLIENT"] = 2] = "SNAPCHAT_CLIENT";
    /** WEB_CLIENT - Web Client Id. */
    IdType[IdType["WEB_CLIENT"] = 3] = "WEB_CLIENT";
    /** WEB_SNAPCHAT_USER - Web Snapchat User Id. */
    IdType[IdType["WEB_SNAPCHAT_USER"] = 4] = "WEB_SNAPCHAT_USER";
    /** AD_ACCOUNT - Ad account ID */
    IdType[IdType["AD_ACCOUNT"] = 5] = "AD_ACCOUNT";
    /** AM_ORGANIZATION - Ads Manager organization ID */
    IdType[IdType["AM_ORGANIZATION"] = 6] = "AM_ORGANIZATION";
    /** AM_MEMBER - Ads Manager member ID */
    IdType[IdType["AM_MEMBER"] = 7] = "AM_MEMBER";
    /** AM_SESSION - Ads Manager session ID */
    IdType[IdType["AM_SESSION"] = 8] = "AM_SESSION";
    /** AM_PROFILE - Ads Manager profile ID */
    IdType[IdType["AM_PROFILE"] = 9] = "AM_PROFILE";
    /** AM_SNAPCHAT_USER - Snapchat user ID on Ads Manager */
    IdType[IdType["AM_SNAPCHAT_USER"] = 10] = "AM_SNAPCHAT_USER";
    /** SNAPCHAT_ADVERTISING - Snapchat Advertising ID for Budget A/B */
    IdType[IdType["SNAPCHAT_ADVERTISING"] = 11] = "SNAPCHAT_ADVERTISING";
    /** AM_CLIENT - Ads Manager client ID */
    IdType[IdType["AM_CLIENT"] = 12] = "AM_CLIENT";
    /** CONFIG_DEVICE - Permanent device ID */
    IdType[IdType["CONFIG_DEVICE"] = 13] = "CONFIG_DEVICE";
    IdType[IdType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(IdType = exports.IdType || (exports.IdType = {}));
/** Type of logging */
var LoggingType;
(function (LoggingType) {
    /** UNSET - Default, please don't use. */
    LoggingType[LoggingType["UNSET"] = 0] = "UNSET";
    /** SERVER_TRIGGER - Server trigger. */
    LoggingType[LoggingType["SERVER_TRIGGER"] = 1] = "SERVER_TRIGGER";
    /** CLIENT_TRIGGER - Client trigger. */
    LoggingType[LoggingType["CLIENT_TRIGGER"] = 2] = "CLIENT_TRIGGER";
    /** ALLOCATION - Allocation logging. */
    LoggingType[LoggingType["ALLOCATION"] = 3] = "ALLOCATION";
    LoggingType[LoggingType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(LoggingType = exports.LoggingType || (exports.LoggingType = {}));
const baseStudyTreatmentInfo = { studyName: "", treatmentId: 0 };
exports.StudyTreatmentInfo = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.studyName !== "") {
            writer.uint32(10).string(message.studyName);
        }
        if (message.treatmentId !== 0) {
            writer.uint32(16).uint32(message.treatmentId);
        }
        if (message.expGuid !== undefined) {
            guid_1.Guid.encode(message.expGuid, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseStudyTreatmentInfo);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.studyName = reader.string();
                    break;
                case 2:
                    message.treatmentId = reader.uint32();
                    break;
                case 3:
                    message.expGuid = guid_1.Guid.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseStudyTreatmentInfo);
        if (object.studyName !== undefined && object.studyName !== null) {
            message.studyName = object.studyName;
        }
        else {
            message.studyName = "";
        }
        if (object.treatmentId !== undefined && object.treatmentId !== null) {
            message.treatmentId = object.treatmentId;
        }
        else {
            message.treatmentId = 0;
        }
        if (object.expGuid !== undefined && object.expGuid !== null) {
            message.expGuid = guid_1.Guid.fromPartial(object.expGuid);
        }
        else {
            message.expGuid = undefined;
        }
        return message;
    },
};
const baseId = { value: "", type: 0 };
exports.Id = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.value !== "") {
            writer.uint32(10).string(message.value);
        }
        if (message.type !== 0) {
            writer.uint32(16).int32(message.type);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseId);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.value = reader.string();
                    break;
                case 2:
                    message.type = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseId);
        if (object.value !== undefined && object.value !== null) {
            message.value = object.value;
        }
        else {
            message.value = "";
        }
        if (object.type !== undefined && object.type !== null) {
            message.type = object.type;
        }
        else {
            message.type = 0;
        }
        return message;
    },
};
const baseGeoData = { countryCode: "", city: "", region: "" };
exports.GeoData = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.countryCode !== "") {
            writer.uint32(10).string(message.countryCode);
        }
        if (message.city !== "") {
            writer.uint32(18).string(message.city);
        }
        if (message.region !== "") {
            writer.uint32(26).string(message.region);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseGeoData);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.countryCode = reader.string();
                    break;
                case 2:
                    message.city = reader.string();
                    break;
                case 3:
                    message.region = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseGeoData);
        if (object.countryCode !== undefined && object.countryCode !== null) {
            message.countryCode = object.countryCode;
        }
        else {
            message.countryCode = "";
        }
        if (object.city !== undefined && object.city !== null) {
            message.city = object.city;
        }
        else {
            message.city = "";
        }
        if (object.region !== undefined && object.region !== null) {
            message.region = object.region;
        }
        else {
            message.region = "";
        }
        return message;
    },
};
const baseUpdateAbExposureRequest = { userName: "", loggingType: 0 };
exports.UpdateAbExposureRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.studyTreatmentInfo) {
            exports.StudyTreatmentInfo.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.id !== undefined) {
            exports.Id.encode(message.id, writer.uint32(18).fork()).ldelim();
        }
        if (message.userName !== "") {
            writer.uint32(26).string(message.userName);
        }
        if (message.userAgentInfo !== undefined) {
            ab_config_service_1.UserAgentInfo.encode(message.userAgentInfo, writer.uint32(34).fork()).ldelim();
        }
        if (message.geoData !== undefined) {
            exports.GeoData.encode(message.geoData, writer.uint32(42).fork()).ldelim();
        }
        if (message.loggingType !== 0) {
            writer.uint32(48).int32(message.loggingType);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseUpdateAbExposureRequest);
        message.studyTreatmentInfo = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.studyTreatmentInfo.push(exports.StudyTreatmentInfo.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.id = exports.Id.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.userName = reader.string();
                    break;
                case 4:
                    message.userAgentInfo = ab_config_service_1.UserAgentInfo.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.geoData = exports.GeoData.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.loggingType = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseUpdateAbExposureRequest);
        message.studyTreatmentInfo = [];
        if (object.studyTreatmentInfo !== undefined &&
            object.studyTreatmentInfo !== null) {
            for (const e of object.studyTreatmentInfo) {
                message.studyTreatmentInfo.push(exports.StudyTreatmentInfo.fromPartial(e));
            }
        }
        if (object.id !== undefined && object.id !== null) {
            message.id = exports.Id.fromPartial(object.id);
        }
        else {
            message.id = undefined;
        }
        if (object.userName !== undefined && object.userName !== null) {
            message.userName = object.userName;
        }
        else {
            message.userName = "";
        }
        if (object.userAgentInfo !== undefined && object.userAgentInfo !== null) {
            message.userAgentInfo = ab_config_service_1.UserAgentInfo.fromPartial(object.userAgentInfo);
        }
        else {
            message.userAgentInfo = undefined;
        }
        if (object.geoData !== undefined && object.geoData !== null) {
            message.geoData = exports.GeoData.fromPartial(object.geoData);
        }
        else {
            message.geoData = undefined;
        }
        if (object.loggingType !== undefined && object.loggingType !== null) {
            message.loggingType = object.loggingType;
        }
        else {
            message.loggingType = 0;
        }
        return message;
    },
};
const baseProperties = {
    userName: "",
    userAgentString: "",
    os: "",
    deviceName: "",
    browserName: "",
    locale: "",
    osVersion: "",
    appVersion: "",
    appBuild: "",
};
exports.Properties = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.userName !== "") {
            writer.uint32(10).string(message.userName);
        }
        if (message.userAgentString !== "") {
            writer.uint32(18).string(message.userAgentString);
        }
        if (message.geoData !== undefined) {
            exports.GeoData.encode(message.geoData, writer.uint32(26).fork()).ldelim();
        }
        if (message.os !== "") {
            writer.uint32(34).string(message.os);
        }
        if (message.deviceName !== "") {
            writer.uint32(42).string(message.deviceName);
        }
        if (message.browserName !== "") {
            writer.uint32(50).string(message.browserName);
        }
        if (message.locale !== "") {
            writer.uint32(58).string(message.locale);
        }
        if (message.osVersion !== "") {
            writer.uint32(66).string(message.osVersion);
        }
        if (message.appVersion !== "") {
            writer.uint32(74).string(message.appVersion);
        }
        if (message.appBuild !== "") {
            writer.uint32(82).string(message.appBuild);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseProperties);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.userName = reader.string();
                    break;
                case 2:
                    message.userAgentString = reader.string();
                    break;
                case 3:
                    message.geoData = exports.GeoData.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.os = reader.string();
                    break;
                case 5:
                    message.deviceName = reader.string();
                    break;
                case 6:
                    message.browserName = reader.string();
                    break;
                case 7:
                    message.locale = reader.string();
                    break;
                case 8:
                    message.osVersion = reader.string();
                    break;
                case 9:
                    message.appVersion = reader.string();
                    break;
                case 10:
                    message.appBuild = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseProperties);
        if (object.userName !== undefined && object.userName !== null) {
            message.userName = object.userName;
        }
        else {
            message.userName = "";
        }
        if (object.userAgentString !== undefined &&
            object.userAgentString !== null) {
            message.userAgentString = object.userAgentString;
        }
        else {
            message.userAgentString = "";
        }
        if (object.geoData !== undefined && object.geoData !== null) {
            message.geoData = exports.GeoData.fromPartial(object.geoData);
        }
        else {
            message.geoData = undefined;
        }
        if (object.os !== undefined && object.os !== null) {
            message.os = object.os;
        }
        else {
            message.os = "";
        }
        if (object.deviceName !== undefined && object.deviceName !== null) {
            message.deviceName = object.deviceName;
        }
        else {
            message.deviceName = "";
        }
        if (object.browserName !== undefined && object.browserName !== null) {
            message.browserName = object.browserName;
        }
        else {
            message.browserName = "";
        }
        if (object.locale !== undefined && object.locale !== null) {
            message.locale = object.locale;
        }
        else {
            message.locale = "";
        }
        if (object.osVersion !== undefined && object.osVersion !== null) {
            message.osVersion = object.osVersion;
        }
        else {
            message.osVersion = "";
        }
        if (object.appVersion !== undefined && object.appVersion !== null) {
            message.appVersion = object.appVersion;
        }
        else {
            message.appVersion = "";
        }
        if (object.appBuild !== undefined && object.appBuild !== null) {
            message.appBuild = object.appBuild;
        }
        else {
            message.appBuild = "";
        }
        return message;
    },
};
const baseUpdateAbExposureResponse = {};
exports.UpdateAbExposureResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseUpdateAbExposureResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseUpdateAbExposureResponse);
        return message;
    },
};
const baseAbExposureData = { loggingType: 0 };
exports.AbExposureData = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.id !== undefined) {
            exports.Id.encode(message.id, writer.uint32(10).fork()).ldelim();
        }
        for (const v of message.studyTreatmentInfo) {
            exports.StudyTreatmentInfo.encode(v, writer.uint32(18).fork()).ldelim();
        }
        if (message.properties !== undefined) {
            exports.Properties.encode(message.properties, writer.uint32(26).fork()).ldelim();
        }
        if (message.loggingType !== 0) {
            writer.uint32(32).int32(message.loggingType);
        }
        for (const v of message.secondaryIds) {
            exports.Id.encode(v, writer.uint32(42).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseAbExposureData);
        message.studyTreatmentInfo = [];
        message.secondaryIds = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.id = exports.Id.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.studyTreatmentInfo.push(exports.StudyTreatmentInfo.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.properties = exports.Properties.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.loggingType = reader.int32();
                    break;
                case 5:
                    message.secondaryIds.push(exports.Id.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseAbExposureData);
        message.studyTreatmentInfo = [];
        message.secondaryIds = [];
        if (object.id !== undefined && object.id !== null) {
            message.id = exports.Id.fromPartial(object.id);
        }
        else {
            message.id = undefined;
        }
        if (object.studyTreatmentInfo !== undefined &&
            object.studyTreatmentInfo !== null) {
            for (const e of object.studyTreatmentInfo) {
                message.studyTreatmentInfo.push(exports.StudyTreatmentInfo.fromPartial(e));
            }
        }
        if (object.properties !== undefined && object.properties !== null) {
            message.properties = exports.Properties.fromPartial(object.properties);
        }
        else {
            message.properties = undefined;
        }
        if (object.loggingType !== undefined && object.loggingType !== null) {
            message.loggingType = object.loggingType;
        }
        else {
            message.loggingType = 0;
        }
        if (object.secondaryIds !== undefined && object.secondaryIds !== null) {
            for (const e of object.secondaryIds) {
                message.secondaryIds.push(exports.Id.fromPartial(e));
            }
        }
        return message;
    },
};
const baseBatchUpdateAbExposureRequest = { disableLogging: false };
exports.BatchUpdateAbExposureRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.abExposureData) {
            exports.AbExposureData.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.disableLogging === true) {
            writer.uint32(16).bool(message.disableLogging);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseBatchUpdateAbExposureRequest);
        message.abExposureData = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.abExposureData.push(exports.AbExposureData.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.disableLogging = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseBatchUpdateAbExposureRequest);
        message.abExposureData = [];
        if (object.abExposureData !== undefined && object.abExposureData !== null) {
            for (const e of object.abExposureData) {
                message.abExposureData.push(exports.AbExposureData.fromPartial(e));
            }
        }
        if (object.disableLogging !== undefined && object.disableLogging !== null) {
            message.disableLogging = object.disableLogging;
        }
        else {
            message.disableLogging = false;
        }
        return message;
    },
};
const baseBatchUpdateAbExposureResponse = {};
exports.BatchUpdateAbExposureResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseBatchUpdateAbExposureResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseBatchUpdateAbExposureResponse);
        return message;
    },
};
const baseAbExposureSizeRequestData = {
    loggingType: 0,
    segmentStudyName: "",
};
exports.AbExposureSizeRequestData = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.loggingType !== 0) {
            writer.uint32(8).int32(message.loggingType);
        }
        for (const v of message.segmentStudyName) {
            writer.uint32(18).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseAbExposureSizeRequestData);
        message.segmentStudyName = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.loggingType = reader.int32();
                    break;
                case 2:
                    message.segmentStudyName.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseAbExposureSizeRequestData);
        message.segmentStudyName = [];
        if (object.loggingType !== undefined && object.loggingType !== null) {
            message.loggingType = object.loggingType;
        }
        else {
            message.loggingType = 0;
        }
        if (object.segmentStudyName !== undefined &&
            object.segmentStudyName !== null) {
            for (const e of object.segmentStudyName) {
                message.segmentStudyName.push(e);
            }
        }
        return message;
    },
};
const baseGetAbExposureSizeRequest = {};
exports.GetAbExposureSizeRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.abExposureSizeRequestData) {
            exports.AbExposureSizeRequestData.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseGetAbExposureSizeRequest);
        message.abExposureSizeRequestData = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.abExposureSizeRequestData.push(exports.AbExposureSizeRequestData.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseGetAbExposureSizeRequest);
        message.abExposureSizeRequestData = [];
        if (object.abExposureSizeRequestData !== undefined &&
            object.abExposureSizeRequestData !== null) {
            for (const e of object.abExposureSizeRequestData) {
                message.abExposureSizeRequestData.push(exports.AbExposureSizeRequestData.fromPartial(e));
            }
        }
        return message;
    },
};
const baseStudyTreatmentInfoWithExposureSizeData = { exposureSize: 0 };
exports.StudyTreatmentInfoWithExposureSizeData = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.studyTreatmentInfo !== undefined) {
            exports.StudyTreatmentInfo.encode(message.studyTreatmentInfo, writer.uint32(10).fork()).ldelim();
        }
        if (message.exposureSize !== 0) {
            writer.uint32(16).int64(message.exposureSize);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseStudyTreatmentInfoWithExposureSizeData);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.studyTreatmentInfo = exports.StudyTreatmentInfo.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.exposureSize = longToNumber(reader.int64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseStudyTreatmentInfoWithExposureSizeData);
        if (object.studyTreatmentInfo !== undefined &&
            object.studyTreatmentInfo !== null) {
            message.studyTreatmentInfo = exports.StudyTreatmentInfo.fromPartial(object.studyTreatmentInfo);
        }
        else {
            message.studyTreatmentInfo = undefined;
        }
        if (object.exposureSize !== undefined && object.exposureSize !== null) {
            message.exposureSize = object.exposureSize;
        }
        else {
            message.exposureSize = 0;
        }
        return message;
    },
};
const baseAbExposureSizeResponseData = { loggingType: 0 };
exports.AbExposureSizeResponseData = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.loggingType !== 0) {
            writer.uint32(8).int32(message.loggingType);
        }
        for (const v of message.studyTreatmentInfoWithExposureSizeData) {
            exports.StudyTreatmentInfoWithExposureSizeData.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseAbExposureSizeResponseData);
        message.studyTreatmentInfoWithExposureSizeData = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.loggingType = reader.int32();
                    break;
                case 2:
                    message.studyTreatmentInfoWithExposureSizeData.push(exports.StudyTreatmentInfoWithExposureSizeData.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseAbExposureSizeResponseData);
        message.studyTreatmentInfoWithExposureSizeData = [];
        if (object.loggingType !== undefined && object.loggingType !== null) {
            message.loggingType = object.loggingType;
        }
        else {
            message.loggingType = 0;
        }
        if (object.studyTreatmentInfoWithExposureSizeData !== undefined &&
            object.studyTreatmentInfoWithExposureSizeData !== null) {
            for (const e of object.studyTreatmentInfoWithExposureSizeData) {
                message.studyTreatmentInfoWithExposureSizeData.push(exports.StudyTreatmentInfoWithExposureSizeData.fromPartial(e));
            }
        }
        return message;
    },
};
const baseGetAbExposureSizeResponse = {};
exports.GetAbExposureSizeResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.abExposureSizeResponseData) {
            exports.AbExposureSizeResponseData.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseGetAbExposureSizeResponse);
        message.abExposureSizeResponseData = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.abExposureSizeResponseData.push(exports.AbExposureSizeResponseData.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseGetAbExposureSizeResponse);
        message.abExposureSizeResponseData = [];
        if (object.abExposureSizeResponseData !== undefined &&
            object.abExposureSizeResponseData !== null) {
            for (const e of object.abExposureSizeResponseData) {
                message.abExposureSizeResponseData.push(exports.AbExposureSizeResponseData.fromPartial(e));
            }
        }
        return message;
    },
};
const baseGetAbExposureStreamingRequest = { loggingType: 0 };
exports.GetAbExposureStreamingRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.loggingType !== 0) {
            writer.uint32(8).int32(message.loggingType);
        }
        if (message.id !== undefined) {
            exports.Id.encode(message.id, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseGetAbExposureStreamingRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.loggingType = reader.int32();
                    break;
                case 2:
                    message.id = exports.Id.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseGetAbExposureStreamingRequest);
        if (object.loggingType !== undefined && object.loggingType !== null) {
            message.loggingType = object.loggingType;
        }
        else {
            message.loggingType = 0;
        }
        if (object.id !== undefined && object.id !== null) {
            message.id = exports.Id.fromPartial(object.id);
        }
        else {
            message.id = undefined;
        }
        return message;
    },
};
const baseGetAbExposureStreamingResponse = { loggingType: 0 };
exports.GetAbExposureStreamingResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.studyTreatmentInfo) {
            exports.StudyTreatmentInfo.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.loggingType !== 0) {
            writer.uint32(16).int32(message.loggingType);
        }
        if (message.id !== undefined) {
            exports.Id.encode(message.id, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseGetAbExposureStreamingResponse);
        message.studyTreatmentInfo = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.studyTreatmentInfo.push(exports.StudyTreatmentInfo.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.loggingType = reader.int32();
                    break;
                case 3:
                    message.id = exports.Id.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseGetAbExposureStreamingResponse);
        message.studyTreatmentInfo = [];
        if (object.studyTreatmentInfo !== undefined &&
            object.studyTreatmentInfo !== null) {
            for (const e of object.studyTreatmentInfo) {
                message.studyTreatmentInfo.push(exports.StudyTreatmentInfo.fromPartial(e));
            }
        }
        if (object.loggingType !== undefined && object.loggingType !== null) {
            message.loggingType = object.loggingType;
        }
        else {
            message.loggingType = 0;
        }
        if (object.id !== undefined && object.id !== null) {
            message.id = exports.Id.fromPartial(object.id);
        }
        else {
            message.id = undefined;
        }
        return message;
    },
};
const baseAbExposureReadRequestData = { loggingType: 0 };
exports.AbExposureReadRequestData = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.loggingType !== 0) {
            writer.uint32(8).int32(message.loggingType);
        }
        for (const v of message.id) {
            exports.Id.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseAbExposureReadRequestData);
        message.id = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.loggingType = reader.int32();
                    break;
                case 2:
                    message.id.push(exports.Id.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseAbExposureReadRequestData);
        message.id = [];
        if (object.loggingType !== undefined && object.loggingType !== null) {
            message.loggingType = object.loggingType;
        }
        else {
            message.loggingType = 0;
        }
        if (object.id !== undefined && object.id !== null) {
            for (const e of object.id) {
                message.id.push(exports.Id.fromPartial(e));
            }
        }
        return message;
    },
};
const baseGetAbExposureRequest = { studyUpdateTimeEpochSec: 0 };
exports.GetAbExposureRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.abExposureReadRequestData) {
            exports.AbExposureReadRequestData.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.studyUpdateTimeEpochSec !== 0) {
            writer.uint32(16).int64(message.studyUpdateTimeEpochSec);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseGetAbExposureRequest);
        message.abExposureReadRequestData = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.abExposureReadRequestData.push(exports.AbExposureReadRequestData.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.studyUpdateTimeEpochSec = longToNumber(reader.int64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseGetAbExposureRequest);
        message.abExposureReadRequestData = [];
        if (object.abExposureReadRequestData !== undefined &&
            object.abExposureReadRequestData !== null) {
            for (const e of object.abExposureReadRequestData) {
                message.abExposureReadRequestData.push(exports.AbExposureReadRequestData.fromPartial(e));
            }
        }
        if (object.studyUpdateTimeEpochSec !== undefined &&
            object.studyUpdateTimeEpochSec !== null) {
            message.studyUpdateTimeEpochSec = object.studyUpdateTimeEpochSec;
        }
        else {
            message.studyUpdateTimeEpochSec = 0;
        }
        return message;
    },
};
const basePerIdExposureData = {};
exports.PerIdExposureData = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.id !== undefined) {
            exports.Id.encode(message.id, writer.uint32(10).fork()).ldelim();
        }
        for (const v of message.studyTreatmentInfo) {
            exports.StudyTreatmentInfo.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, basePerIdExposureData);
        message.studyTreatmentInfo = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.id = exports.Id.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.studyTreatmentInfo.push(exports.StudyTreatmentInfo.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = Object.assign({}, basePerIdExposureData);
        message.studyTreatmentInfo = [];
        if (object.id !== undefined && object.id !== null) {
            message.id = exports.Id.fromPartial(object.id);
        }
        else {
            message.id = undefined;
        }
        if (object.studyTreatmentInfo !== undefined &&
            object.studyTreatmentInfo !== null) {
            for (const e of object.studyTreatmentInfo) {
                message.studyTreatmentInfo.push(exports.StudyTreatmentInfo.fromPartial(e));
            }
        }
        return message;
    },
};
const baseAbExposureReadResponseData = { loggingType: 0 };
exports.AbExposureReadResponseData = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.loggingType !== 0) {
            writer.uint32(8).int32(message.loggingType);
        }
        for (const v of message.perIdExposureData) {
            exports.PerIdExposureData.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseAbExposureReadResponseData);
        message.perIdExposureData = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.loggingType = reader.int32();
                    break;
                case 2:
                    message.perIdExposureData.push(exports.PerIdExposureData.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseAbExposureReadResponseData);
        message.perIdExposureData = [];
        if (object.loggingType !== undefined && object.loggingType !== null) {
            message.loggingType = object.loggingType;
        }
        else {
            message.loggingType = 0;
        }
        if (object.perIdExposureData !== undefined &&
            object.perIdExposureData !== null) {
            for (const e of object.perIdExposureData) {
                message.perIdExposureData.push(exports.PerIdExposureData.fromPartial(e));
            }
        }
        return message;
    },
};
const baseGetAbExposureResponse = {};
exports.GetAbExposureResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.abExposureReadResponseData) {
            exports.AbExposureReadResponseData.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseGetAbExposureResponse);
        message.abExposureReadResponseData = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.abExposureReadResponseData.push(exports.AbExposureReadResponseData.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseGetAbExposureResponse);
        message.abExposureReadResponseData = [];
        if (object.abExposureReadResponseData !== undefined &&
            object.abExposureReadResponseData !== null) {
            for (const e of object.abExposureReadResponseData) {
                message.abExposureReadResponseData.push(exports.AbExposureReadResponseData.fromPartial(e));
            }
        }
        return message;
    },
};
const baseUpdateAbExposureStreamingRequest = { disableLogging: false };
exports.UpdateAbExposureStreamingRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.abExposureData) {
            exports.AbExposureData.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.disableLogging === true) {
            writer.uint32(16).bool(message.disableLogging);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseUpdateAbExposureStreamingRequest);
        message.abExposureData = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.abExposureData.push(exports.AbExposureData.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.disableLogging = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseUpdateAbExposureStreamingRequest);
        message.abExposureData = [];
        if (object.abExposureData !== undefined && object.abExposureData !== null) {
            for (const e of object.abExposureData) {
                message.abExposureData.push(exports.AbExposureData.fromPartial(e));
            }
        }
        if (object.disableLogging !== undefined && object.disableLogging !== null) {
            message.disableLogging = object.disableLogging;
        }
        else {
            message.disableLogging = false;
        }
        return message;
    },
};
const baseUpdateAbExposureStreamingResponse = { message: "" };
exports.UpdateAbExposureStreamingResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.message !== "") {
            writer.uint32(10).string(message.message);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseUpdateAbExposureStreamingResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.message = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseUpdateAbExposureStreamingResponse);
        if (object.message !== undefined && object.message !== null) {
            message.message = object.message;
        }
        else {
            message.message = "";
        }
        return message;
    },
};
var globalThis = (() => {
    if (typeof globalThis !== "undefined")
        return globalThis;
    if (typeof self !== "undefined")
        return self;
    if (typeof window !== "undefined")
        return window;
    if (typeof global !== "undefined")
        return global;
    throw "Unable to locate global object";
})();
function longToNumber(long) {
    if (long.gt(Number.MAX_SAFE_INTEGER)) {
        throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
    }
    return long.toNumber();
}
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
//# sourceMappingURL=exposure_service.js.map